<script lang="ts">
	import FilterIcon from '../../../../../assets/icons/FilterIcon/FilterIcon.svelte';
	import { Button } from '../../../../../components/Button';
	import { createDialogStores } from '../../../../../components/Dialog';
	import { Txt } from '../../../../../components/Txt';
	import { filterStores } from '../../../state';
	import type { FilterSections, FilterDrawerState } from '../../../types';
	import { getFilterCount } from '../../../utils/getFilterCount/getFilterCount';
	import { setFilter } from '../../../utils/setFilter/setFilter';
	import { FilterDrawer } from '../../FilterDrawer';
	import type { FilterTypesClasses } from '../../FilterTypes/FilterTypes.svelte';
	import { page } from '$app/state';

	let {
		classes = {},
		filterSections,
		withMaxSectionHeight,
		pageParams,
		scrollTarget = undefined,
		containerClass = undefined,
		trackPrefix = undefined,
		...rest
	}: Props = $props();

	interface Props {
		class?: string;
		containerClass?: string;
		classes?: FilterTypesClasses;
		filterSections: FilterSections;
		withMaxSectionHeight: boolean;
		pageParams: string[];
		scrollTarget?: string;
		trackPrefix?: string;
	}

	let drawerStores = createDialogStores();

	const {
		states: { open }
	} = drawerStores;

	const { filterStore } = filterStores;

	let searchParams = $derived(page.url.searchParams);

	let count = $derived(
		getFilterCount({
			searchParams,
			filter: $filterStore as FilterDrawerState
		})
	);

	const handleClick = () => {
		open.update(() => true);
	};

	open.subscribe(() => {
		setFilter({
			filterSections,
			searchParams: page.url.searchParams,
			pageParams,
			trackPrefix
		});
	});
</script>

<div class={containerClass}>
	<Button
		icon
		dataCy="open-filter-drawer"
		variant="secondary"
		size="md"
		fullWidth
		onclick={handleClick}
		class={rest.class}
	>
		{#snippet leading()}
			<span>
				{#if count}
					<span
						class="mr-0.5 flex h-[16px] w-[16px] items-center justify-center rounded-full bg-gray-900"
					>
						<Txt variant="body3" class="text-[.625rem] font-bold leading-[.625rem] text-gray-50">
							{count}
						</Txt>
					</span>
				{/if}
			</span>
		{/snippet}

		FILTERS

		{#snippet trailing()}
			<FilterIcon class="h-[16px] w-[16px]" />
		{/snippet}
	</Button>

	<FilterDrawer {classes} {filterSections} {drawerStores} {withMaxSectionHeight} {scrollTarget} />
</div>
